/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { ErrorDefDTO } from './errorDefDTO';


export interface Issues { 
    /**
     * List of errors.
     */
    errors?: Array<string>;
    /**
     * List of detailed errors.
     */
    error_details?: Array<ErrorDefDTO>;
    /**
     * List of warnings.
     */
    warnings?: Array<string>;
    /**
     * List of detailed warnings.
     */
    warning_details?: Array<ErrorDefDTO>;
}

